// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021vocational/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getVoteList = (page: number, search?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search,
    },
  });
};

const getDetail = (id: string | number) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

export { getBaseInfo, getRule, getVoteList, getDetail };
